import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
// Import styles
import styles from './style.scss';

@inject('MediahubStore', 'ViewStore')
@observer
class FeaturedMediaContainer extends Component {
  @observable loaded = false;
  @observable faded  = false;

  @computed
  get opacity() {
    return this.faded
      ? 1
      : 0;
  }

  componentDidMount() {
    this._fadeInImage();
    this._fadeInContainer();
  }

  componentDidUpdate() {
    this._fadeInImage();
  }

  _fadeInImage() {
    const { mc } = this.props;

    if(mc.thumbnail) {
      const img  = new Image();
      img.onload = this._onImageLoad.bind(this);
      img.src    = mc.thumbnail;
    }
  }

  _fadeInContainer() {
    _.delay(action(() => {
      this.faded = true;
    }), 60);
  }

  _onImageLoad() {
    _.delay(() => {
      this._changeLoaded(true);
    }, 500);
  }

  @action
  _changeLoaded(bool) {
    this.loaded = bool;
  }

  navigateToMc(mc) {
    const { ViewStore } = this.props;
    const lang          = ViewStore.language;
    const directLink    = _.split(mc.directLink, '/');
    const channel       = _.head(directLink);
    const detail        = _.last(directLink);

    ViewStore.router.navigate('detail', {
      lang:    ViewStore.language,
      channel: channel,
      detail:  detail,
    }, {});
  }

  render() {
    const { MediahubStore } = this.props;
    const { mc }            = this.props;

    if(!mc) {
      return null;
    }

    return (
      <div
        className={styles.mediaContainer + ' row'}
        style={{ opacity: this.opacity }}
        onClick={() => this.navigateToMc(mc)}
        >
        <div className={styles.background_color}></div>

        <div
        className={styles.playerContainer + ' col-xs-8'}
        tabIndex={0}
        aria-label={mc.title}
        >
          <div className={styles.player} >
          {/* <img
             className={styles.emptyImage}
              src={mc.previewImage}
              tabIndex={ 0 }
              alt={mc.title} /> */}
            {
              mc.player && (
                <iframe
                  src={mc.player}
                  scrolling='no'
                  frameBorder='0'
                  allowFullScreen={true}
                  tabIndex={ 0 }
                  />
              )
            }
          </div >
        </div >

        <div className={styles.infoContainer + ' col-xs-4'} >
          <h2
          className={styles.mcTitle} >
            {mc.title}
          </h2 >

          <p className={styles.mcInfo} >
            {`${mc.created} | ${mc.duration} `}
          </p >

          <p className={styles.mcDescription} >
            {_.truncate(mc.description, { length: 380, separator: ' ' })}
          </p >
        </div >
      </div >
    );
  }
}

export default FeaturedMediaContainer;



// WEBPACK FOOTER //
// ./src/components/Featured/index.js